// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8758631c","124":"195b9562","150":"b775fa55","162":"7438ee60","204":"5cd9f556","374":"86e9be68","382":"32b7d12d","410":"d2b1d925","453":"51a16142","659":"45f54c74","662":"fbf7cc5a","940":"d4618cba"}[chunkId] + ".chunk.js";
};